// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SnippetsTwoToneSvg from "@ant-design/icons-svg/es/asn/SnippetsTwoTone";
import AntdIcon from '../components/AntdIcon';

var SnippetsTwoTone = function SnippetsTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SnippetsTwoToneSvg
  }));
};

SnippetsTwoTone.displayName = 'SnippetsTwoTone';
export default React.forwardRef(SnippetsTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SnippetsTwoTone.js
// module id = 1847
// module chunks = 0